import React from 'react'
import "./Home.css"
import { TbLineDotted } from "react-icons/tb";
import Home2 from '../Home2/Home2';

const Home = () => {
    return (
        <div className='home-main ' id="home">
            <div className="home-orb o1"></div>
            <div className="home-orb o2"></div>

            <div className="home-container">
                <div className="left-home">
                    <div className="home-left-head">
                        <span><TbLineDotted /> A Business Associate of Motilal Oswal</span>
                    </div>
                    <div className="home-left-title">
                        <p>Where wealth<br />begins, on paper<br />and in practice.</p>
                    </div>
                    <div className="home-left-p">
                        <p>Personal advisory, MOFSL-backed research, and a straightforward account-opening process — built for investors in Patiala and beyond who want a local partner they can actually call.</p>
                    </div>
                    <div className="home-left-buttons">
                        <div className="l-button-1">
                            <a href="https://mosl.co/MOSWEB/xwcaiDZIkj">OPEN AN ACCOUNT</a>
                        </div>
                        <div className="l-button-2">
                            <a href="#ser">VIEW SERVICES</a>
                        </div>
                    </div>
                    <div className="home-left-line" />
                    <div className="home-left-end">
                        <div className="left-end-1">
                            <h1>MOFSL</h1>
                        </div>
                        <div className="left-end-2">
                            <h1>Group backing</h1>
                        </div>
                    </div>
                    <div className="home-left-end">
                        <div className="left-end-1">
                            <h1>1:1</h1>
                        </div>
                        <div className="left-end-2">
                            <h1>Personal advisory</h1>
                        </div>
                    </div>
                    <div className="home-left-end">
                        <div className="left-end-1">
                            <h1>Local</h1>
                        </div>
                        <div className="left-end-2">
                            <h1>Patiala presence</h1>
                        </div>
                    </div>
                    <div className="home-left-end">
                        <div className="left-end-1">
                            <h1>Same-day</h1>
                        </div>
                        <div className="left-end-2">
                            <h1>Account activation</h1>
                        </div>
                    </div>
                </div>

               <div className="right-home">
                    <svg viewBox="0 0 420 440" fill="none">
                        <line className="grid-line" x1="0" y1="80" x2="420" y2="80" />
                        <line className="grid-line" x1="0" y1="180" x2="420" y2="180" />
                        <line className="grid-line" x1="0" y1="280" x2="420" y2="280" />
                        <line className="grid-line" x1="0" y1="380" x2="420" y2="380" />
                        <g>
                            <rect className="candle-flat" x="20" y="330" width="10" height="50" fill="#e05252" />
                            <rect className="candle-up" x="46" y="300" width="10" height="70" fill="#4caf50" />
                            <rect className="candle-flat" x="72" y="310" width="10" height="40" fill="#e05252" />
                            <rect className="candle-up" x="98" y="260" width="10" height="80" fill="#4caf50" />
                            <rect className="candle-up" x="124" y="230" width="10" height="70" fill="#4caf50" />
                            <rect className="candle-flat" x="150" y="240" width="10" height="40" fill="#e05252" />
                            <rect className="candle-up" x="176" y="190" width="10" height="80" fill="#4caf50" />
                            <rect className="candle-up" x="202" y="160" width="10" height="70" fill="#4caf50" />
                            <rect className="candle-flat" x="228" y="175" width="10" height="35" fill="#e05252" />
                            <rect className="candle-up" x="254" y="120" width="10" height="90" fill="#4caf50" />
                        </g>
                        <path className="arc-path" d="M20 360 C 100 330, 160 260, 210 200 C 260 140, 320 90, 380 55" />
                        <path
                            className="arc-path"
                            d="M362 40 L382 54 L378 76"
                            stroke="#4d8fe0"
                            strokeWidth="2.5"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            style={{ strokeDasharray: 60, strokeDashoffset: 60, animationDelay: "2.2s" }}
                        />
                        <g className="pulse-dot">
                            <circle cx="380" cy="55" r="3" fill="#4d8fe0" />
                            <circle cx="380" cy="55" r="3" fill="none" stroke="#4d8fe0" strokeWidth="1.5" />
                        </g>
                        <circle className="spark" cx="130" cy="90" r="1.6" style={{ animationDelay: "0.3s" }} />
                        <circle className="spark" cx="300" cy="150" r="2" style={{ animationDelay: "1.3s" }} />
                        <circle className="spark" cx="70" cy="200" r="1.4" style={{ animationDelay: "2.1s" }} />
                        <circle className="spark" cx="340" cy="260" r="1.8" style={{ animationDelay: "0.8s" }} />
                    </svg>

                    <div className="float-card top">
                        <div className="fc-label">Partner Status</div>
                        <div className="fc-value">MOFSL Certified</div>
                    </div>
                    <div className="float-card bottom">
                        <div className="fc-label">Advisory Model</div>
                        <div className="fc-value">1:1 Personal Advisor</div>
                    </div>
                </div>
            </div>
            <Home2/>
        </div>
    )
}

export default Home